export enum AppDocStatus {
    MISSING = 'MISSING',
    FIX_REQUIRED = 'FIX_REQUIRED',
    WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
    SIGNATURE_REQUIRED = 'SIGNATURE_REQUIRED',
    PREAPPROVED = 'PREAPPROVED',
    APPROVED = 'APPROVED',
    // Historical form-workflow values; Postgres cannot drop enum members
    AUTO_FILLED = 'AUTO_FILLED',
    SENT_TO_CLIENT = 'SENT_TO_CLIENT',
    CLIENT_COMPLETED = 'CLIENT_COMPLETED',
    PRE_APPROVED = 'PRE_APPROVED',
}
